<template>
  <div>
    <h1 class="mb-3">
      Your Enquiries
    </h1>

    <b-row class="match-height">
      <b-col
        cols="12"
      >
        <b-card>
          <h2 class="mb-2">
            Enquiry History
          </h2>
          <b-table
            :items="enquiries"
            :fields="enquiryFields"
            responsive
            striped
            hover
          >
            <template #cell(message)="data">
              <div style="max-width: 400px; white-space: pre-wrap;">
                {{ data.value }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>

      <!-- Provider enquiry forms are temporarily hidden. -->
      <b-col
        v-if="false"
        cols="12"
        md="4"
      >
        <b-card
          title="Send Enquiry"
          class="h-100"
        >
          <b-card-text>
            Contact a provider directly about a product.
          </b-card-text>
          <b-form-group label="Provider">
            <b-form-select
              :value="null"
              disabled
            >
              <template #first>
                <b-form-select-option
                  :value="null"
                  disabled
                >
                  -- Select a provider --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Product">
            <b-form-select
              :value="null"
              disabled
            >
              <template #first>
                <b-form-select-option
                  :value="null"
                  disabled
                >
                  -- Select a provider first --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Name">
            <b-form-input
              value="John Smith"
              readonly
            />
          </b-form-group>
          <b-form-group label="Company">
            <b-form-input
              value="Acme Wealth Management"
              readonly
            />
          </b-form-group>
          <b-form-group label="Email Address">
            <b-form-input
              value="j.smith@acmewm.co.uk"
              type="email"
              readonly
            />
          </b-form-group>
          <b-form-group label="Message">
            <b-form-textarea
              placeholder="Enter your message here..."
              rows="3"
              disabled
            />
          </b-form-group>
          <div class="text-right">
            <b-button
              variant="primary"
              disabled
            >
              Submit
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BTable, BFormGroup, BFormInput,
  BFormSelect, BFormSelectOption, BFormTextarea, BButton,
} from 'bootstrap-vue'

export default {
  name: 'YourEnquiriesStatic',
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BTable,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BButton,
  },
  data() {
    return {
      enquiryFields: [
        {
          key: 'datereceived',
          label: 'Date Received',
          sortable: true,
        },
        {
          key: 'provider',
          label: 'Provider',
          sortable: true,
        },
        {
          key: 'reporttitle',
          label: 'Report Title',
          sortable: true,
        },
        {
          key: 'message',
          label: 'Message',
          sortable: false,
        },
      ],
      enquiries: [
        {
          datereceived: '14 Mar 2026',
          provider: 'Barclays',
          reporttitle: 'FTSE 100 Autocall Mar 2026',
          message: 'Could you provide more details on the barrier level and early redemption conditions for this product?',
        },
        {
          datereceived: '02 Mar 2026',
          provider: 'Société Générale',
          reporttitle: 'Euro Stoxx 50 Kick-Out Feb 2026',
          message: 'Please send through the full term sheet and any available stress test data.',
        },
        {
          datereceived: '18 Feb 2026',
          provider: 'Goldman Sachs',
          reporttitle: 'S&P 500 Capital Protected Jan 2026',
          message: 'We are interested in allocating to this product. What is the minimum subscription size?',
        },
        {
          datereceived: '05 Jan 2026',
          provider: 'Morgan Stanley',
          reporttitle: 'FTSE 100 Reverse Convertible Dec 2025',
          message: 'Can you confirm the coupon payment dates and whether early exit is available?',
        },
      ],
    }
  },
}
</script>
